var map = {
	"./athletic-crop-top_fabric.svg": 15489,
	"./beanie_lining-color.svg": 67388,
	"./canvas_canvas-frame.svg": 30113,
	"./classic-crewneck_color.svg": 99197,
	"./classic-pullover-hoodie_color.svg": 91473,
	"./comfort-long-sleeve-t-shirt_color.svg": 15706,
	"./comfort-racerback-tank-top_color.svg": 41326,
	"./comfort-slimfit-t-shirt_color.svg": 5837,
	"./comfort-t-shirt_color.svg": 59254,
	"./cropped-pullover-hoodie_color.svg": 12256,
	"./day-tote_strap-color.svg": 81082,
	"./fitted-polo-shirt_color.svg": 12660,
	"./fitted-skirt_fabric.svg": 6024,
	"./flare-skirt_fabric.svg": 94300,
	"./flow-pullover-hoodie_color.svg": 76025,
	"./flow-racerback-tank-top_color.svg": 51138,
	"./holiday-stocking_loop-color.svg": 49368,
	"./kimono-robe_trim-belt.svg": 61277,
	"./makeup-bag_zipper-color.svg": 36897,
	"./makeup-bag_zipper-pull copy.svg": 16276,
	"./market-tote_fabric.svg": 43455,
	"./market-tote_strap-color.svg": 66344,
	"./market-tote_style/basic.svg": 7380,
	"./market-tote_style/market.svg": 49322,
	"./market-tote_style/none.svg": 30507,
	"./origami-tote_strap-color.svg": 88042,
	"./peignoir_trim-belt.svg": 39740,
	"./premium-crewneck_color.svg": 73128,
	"./premium-long-sleeve-t-shirt_color.svg": 17173,
	"./premium-pullover-hoodie_color.svg": 14842,
	"./premium-slimfit-t-shirt_color.svg": 62130,
	"./premium-t-shirt_color.svg": 96862,
	"./premium-unisex-tank-top_color.svg": 28539,
	"./premium-zipper-hoodie_color.svg": 61841,
	"./spiral-notebook_frosted-polymer-cover/none.svg": 82235,
	"./spiral-notebook_frosted-polymer-cover/with-cover.svg": 39791,
	"./spiral-notebook_frosted-polymer-cover/without-cover.svg": 54669,
	"./spiral-notebook_spiral-color.svg": 83277,
	"./stainless-steel-tumbler_finish/glossy.svg": 46240,
	"./stainless-steel-tumbler_finish/matte.svg": 18386,
	"./stainless-steel-tumbler_finish/none.svg": 35137,
	"./stainless-steel-water-bottle_finish/glossy.svg": 71413,
	"./stainless-steel-water-bottle_finish/matte.svg": 45705,
	"./stainless-steel-water-bottle_finish/none.svg": 27004,
	"./thread-color.svg": 29744,
	"./tote-bag_strap-color.svg": 59312,
	"./tote-bag_style/basic.svg": 56828,
	"./tote-bag_style/none.svg": 72176,
	"./tote-bag_style/urban.svg": 40286,
	"./unisex-joggers_color.svg": 96734,
	"./unisex-polo-shirt_color.svg": 84962,
	"./vegan-leather-backpack_color.svg": 38328,
	"./vegan-leather-crossbody-purse_color.svg": 99716,
	"./vegan-leather-makeup-bag_color.svg": 61666,
	"./vegan-leather-tote-bag_color.svg": 58689,
	"./wrap-skirt_wrap-tie-color.svg": 11508,
	"./yoga-shorts_fabric.svg": 48270,
	"./zipper-carry-all_zipper-color.svg": 29139,
	"./zipper-carry-all_zipper-pull.svg": 85659,
	"./zipper-color.svg": 2098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4448;